import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import createLogger from 'vuex/dist/logger';
import createPersistedState from 'vuex-persistedstate';

import app from './modules/app';
import ad from './modules/ad';
import config from './modules/config';
import product from './modules/product';
import user from './modules/user';
import order from './modules/order';
import cart from './modules/cart';
import article from './modules/article';
import proxy from './modules/proxy';
import rakuten from './modules/rakuten';
import yahoo from './modules/yahoo';
import amazon from './modules/amazon';
import faq from './modules/faq';
import warehouse from './modules/warehouse';
import parcel from './modules/parcel';
// import transportationorderapp from './modules/transportationOrderApp';
// import transportationorder from './modules/transportationOrder';
import appConfig from '../app.config';
import { encrypt, decrypt } from '../plugins/helpers';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const plugins = [
  createPersistedState({
    key: appConfig.VUEX_STORE_KEY,
    storage: appConfig.VUEX_STORE_STORAGE,
    reducer: (persistedState) => {
      const stateFilter = _.cloneDeep(persistedState);
      [
        'wait',
        'app.currency',
        'app.searchKeyword', 'app.searchPlatform', 'app.timeDiff',
        'app.searchToolOpened', 'app.userAgent', 'user.shippingAddressDialog',
      ].forEach(key => _.unset(stateFilter, key));
      return stateFilter;
    },
    getState(key, storage) {
      const data = storage.getItem(key);
      if (data) {
        const state = decrypt(data);
        if (localStorage.getItem('refresh-cache')) {
          storage.removeItem(key);
          localStorage.removeItem('refresh-cache');

          return {
            app: {
              trackID: state.app.trackID,
            },
            user: {
              identity: state.user.identity,
              token: state.user.token,
              expiresTime: state.user.expiresTime,
            },
          };
        }
        return state;
      }
      return null;
    },
    setState(key, data, storage) {
      const encrypted = encrypt(data);
      storage.setItem(key, encrypted);
    },
  }),
];

if (debug) {
  plugins.push(createLogger());
}

export default new Vuex.Store({
  modules: {
    app,
    ad,
    config,
    product,
    user,
    order,
    cart,
    article,
    proxy,
    rakuten,
    yahoo,
    amazon,
    faq,
    warehouse,
    parcel,
    // transportationorderapp,
    // transportationorder,
  },
  strict: true,
  plugins,
});
